// Tickets page

const Tickets = () => (
  <>
    <p>Tickets Jea</p>
  </>
);

export default Tickets;
